import { useFormik } from "formik"
import React, { useEffect, useState } from "react"
import * as Yup from "yup"
import { Button, Card, CardBody, Col, Form, Input, Row } from "reactstrap"
import ErrorPopup from "components/ErrorPopup"
import { useDispatch, useSelector } from "react-redux"
import { updatePvsRegistration } from "../../../redux/actions/pvs"
import { UPDATE_PVS_REGISTRATION_RESET } from "../../../redux/types/pvs"
import { toast } from "react-toastify"
import { useNavigate } from "react-router-dom"

const Step1 = props => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [isErrorOpen, setIsErrorOpen] = useState(false)
  const [isErrorMessage, setIsErrorMessage] = useState("")

  const user = useSelector(state => state.auth.user)
  const pvsFormData = useSelector(state => state.pvs.pvsFormData)
  const updatePvsRegistrationScreen = useSelector(
    state => state.screens.pvs.updatePvsRegistration
  )

  useEffect(() => {
    formik.setValues({
      facebookLink: user ? user.facebook_link : "",
      sellerName: user ? `${user.first_name} ${user.last_name}` : "",
      sellerEmail: user ? user.email_id : "",
      sellerContact: user ? user.contact_no || user.mobile_no : "",
      whatsappNumber: user ? user.mobile_no : "",
      puneAddress: "",
      permanentAddress: "",
      hasPartner: false,
      partnerName: "",
      partnerEmail: "",
      partnerWhatsappNumber: "",
    })
  }, [])

  useEffect(() => {
    if (pvsFormData) {

      formik.setValues({
        facebookLink: pvsFormData.fb_url,
        sellerName: pvsFormData.seller_name,
        sellerEmail: pvsFormData.seller_email_id,
        sellerContact: pvsFormData.seller_contact_no,
        whatsappNumber: pvsFormData.whatsapp_number,
        puneAddress: pvsFormData.address,
        permanentAddress: pvsFormData.permanent_address,
        hasPartner: pvsFormData.team_name && pvsFormData.team_name.length > 0,
        partnerName: pvsFormData.team_name,
        partnerEmail: pvsFormData.team_email,
        partnerWhatsappNumber: pvsFormData.team_mobile,
        partnerFacebookLink: pvsFormData.team_fb_url,
      })
    }
  }, [pvsFormData])

  useEffect(() => {
    if (updatePvsRegistrationScreen.success && props.activeTab === 1) {
      // toast.success(updatePvsRegistrationScreen.message)
      dispatch({ type: UPDATE_PVS_REGISTRATION_RESET })
      props.toggleTab(props.activeTab + 1)
    }
    if (updatePvsRegistrationScreen.error && props.activeTab === 1) {
      toast.error(updatePvsRegistrationScreen.error)
      dispatch({ type: UPDATE_PVS_REGISTRATION_RESET })
    }
  }, [updatePvsRegistrationScreen])

  const formik = useFormik({
    initialValues: {
      facebookLink: "",
      sellerName: "",
      sellerEmail: "",
      sellerContact: "",
      whatsappNumber: "",
      puneAddress: "",
      permanentAddress: "",
      hasPartner: false,
      partnerName: "",
      partnerEmail: "",
      partnerWhatsappNumber: "",
      partnerFacebookLink: "",
    },
    validationSchema: Yup.object({
      facebookLink: Yup.string()
        .url("Facebook link is invalid")
        .required("Facebook Link is required"),
      sellerName: Yup.string().required("Seller Name is required"),
      sellerEmail: Yup.string()
        .email("Email Id is Invalid")
        .required("Email Id is required"),
      sellerContact: Yup.string().required("Contact number is required"),
      whatsappNumber: Yup.string().required("Whatsapp Number is required"),
      puneAddress: Yup.string().required("Pune Address is required"),
      permanentAddress: Yup.string().required("Permanent Address is required"),
      offlineStore: Yup.boolean(),
      hasPartner: Yup.boolean(),
      partnerName: Yup.string().when("hasPartner", {
        is: true,
        then: schema => schema.required("Partner Name is required"),
        otherwise: schema => schema.notRequired(),
      }),
      partnerEmail: Yup.string().when("hasPartner", {
        is: true,
        then: schema =>
          schema
            .email("Partner Email Id is Invalid")
            .required("Partner Email Id is required"),
        otherwise: schema => schema.notRequired(),
      }),
      partnerWhatsappNumber: Yup.string().when("hasPartner", {
        is: true,
        then: schema => schema.required("Partner Whatsapp Number is required"),
        otherwise: schema => schema.notRequired(),
      }),
      partnerFacebookLink: Yup.string().when("hasPartner", {
        is: true,
        then: schema => schema.required("Partner Facebook Link is required"),
        otherwise: schema => schema.notRequired(),
      }),
    }),

    onSubmit: values => {
      let requestData = {
        step: 1,
        pvs_entry_id: "",
        data: {
          fb_url: values.facebookLink,
          seller_name: values.sellerName,
          seller_email_id: values.sellerEmail,
          seller_contact_no: values.sellerContact,
          whatsapp_number: values.whatsappNumber,
          address: values.puneAddress,
          permanent_address: values.permanentAddress,
          team_name: "",
          team_mobile: "",
          team_email: "",
          team_fb_url: "",
        },
      }
      if (values.hasPartner) {
        requestData = {
          ...requestData,
          data: {
            ...requestData.data,
            team_name: values.partnerName,
            team_mobile: values.partnerWhatsappNumber,
            team_email: values.partnerEmail,
            team_fb_url: values.partnerFacebookLink,
          },
        }
      }
      if (pvsFormData && pvsFormData.pvs_entry_id) {
        requestData = {
          ...requestData,
          pvs_entry_id: pvsFormData.pvs_entry_id,
        }
      }

      dispatch(updatePvsRegistration(requestData))
    },
  })

  const normalizeUrlOnBlur = fieldName => () => {
    const value = formik.values[fieldName]?.trim() || ""
    const finalValue =
      value && !/^https?:\/\//i.test(value) ? `https://${value}` : value
    formik.setFieldValue(fieldName, finalValue)
    formik.setFieldTouched(fieldName, true, false)
  }

  useEffect(() => {
    if (props.stepData) {
      formik.setValues(props.stepData)
    }
  }, [props.stepData])

  useEffect(() => {
    if (formik.isSubmitting && formik.errors) {
      formik.setSubmitting(false)
      if (Object.keys(formik.errors).length > 0) {
        let message = (
          <div>
            <ul className="mb-0 ps-3">
              {Object.keys(formik.errors).map(key => (
                <li key={key} className="mb-3">
                  {formik.errors[key]}
                </li>
              ))}
            </ul>
          </div>
        )
        setIsErrorMessage(message)
        setIsErrorOpen(true)
      }
    }
  }, [formik])

  return (
    <div>
      <Form onSubmit={formik.handleSubmit}>
        <Card className="pvs-form-card">
          <CardBody>
            <h4 className="nom-title mb-4">Personal Details</h4>
            {/* Radio Button */}
            <Row className="g-3 mb-3">
              <Col md={6}>
                <div
                  className={`radio-card ${
                    !formik.values.hasPartner ? "active" : ""
                  }`}
                  onClick={() => formik.setFieldValue("hasPartner", false)}
                >
                  <Input
                    type="radio"
                    name="hasPartner"
                    checked={!formik.values.hasPartner}
                    readOnly
                  />
                  <div className="radio-content">
                    <h6>Solopreneur</h6>
                    <p>I'm an individual seller on PULA</p>
                  </div>
                </div>
              </Col>

              <Col md={6}>
                <div
                  className={`radio-card ${
                    formik.values.hasPartner ? "active" : ""
                  }`}
                  onClick={() => formik.setFieldValue("hasPartner", true)}
                >
                  <Input
                    type="radio"
                    name="hasPartner"
                    checked={formik.values.hasPartner}
                    readOnly
                  />
                  <div className="radio-content">
                    <h6>Partner / Team</h6>
                    <p>I have a partner for promoting on PULA</p>
                  </div>
                </div>
              </Col>
            </Row>

            {/* Form Inputs Starts */}
            <Row>
              <Col md={6}>
                <label
                  htmlFor="txtAddress1Billing"
                  className="col-lg-12 col-form-label"
                >
                  Seller Name <span style={{ color: "red" }}>*</span>
                </label>
                <div className="mb-4">
                  <Input
                    id="sellerName"
                    name="sellerName"
                    rows="4"
                    className="form-control"
                    placeholder="Enter your name"
                    value={formik.values.sellerName}
                    onChange={formik.handleChange}
                  ></Input>
                  {formik.errors.sellerName && (
                    <div className="text-danger small mt-1">
                      {formik.errors.sellerName}
                    </div>
                  )}
                </div>
              </Col>
              <Col md={6}>
                <label
                  htmlFor="txtAddress2Billing"
                  className="col-lg-12 col-form-label"
                >
                  Email <span style={{ color: "red" }}>*</span> (Used in the directory)
                </label>
                <div className="mb-4">
                  <Input
                    id="sellerEmail"
                    name="sellerEmail"
                    rows="4"
                    className="form-control"
                    placeholder="Enter your email"
                    value={formik.values.sellerEmail}
                    onChange={formik.handleChange}
                  ></Input>
                  {formik.errors.sellerEmail && (
                    <div className="text-danger small mt-1">
                      {formik.errors.sellerEmail}
                    </div>
                  )}
                </div>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <label
                  htmlFor="txtCityBilling"
                  className="col-lg-12 col-form-label"
                >
                  Whatsapp Number <span style={{ color: "red" }}>*</span> (Used in the directory and linked to the PVS card.)
                </label>
                <div className="mb-4">
                  <Input
                    id="whatsappNumber"
                    name="whatsappNumber"
                    type="tel"
                    maxLength={10}
                    inputMode="numeric"
                    className="form-control"
                    placeholder="Enter your whatsapp number"
                    value={formik.values.whatsappNumber}
                    onChange={formik.handleChange}
                    disabled
                  />
                  {formik.errors.whatsappNumber && (
                    <div className="text-danger small mt-1">
                      {formik.errors.whatsappNumber}
                    </div>
                  )}
                </div>
              </Col>
              <Col md={6}>
                <label
                  htmlFor="txtStateProvinceBilling"
                  className="col-lg-12 col-form-label"
                >
                  Alternate Contact Number <span style={{ color: "red" }}>*</span>
                </label>
                <div className="mb-4">
                  <Input
                    id="sellerContact"
                    name="sellerContact"
                    type="tel"
                    maxLength={10}
                    inputMode="numeric"
                    className="form-control"
                    placeholder="Enter your contact number"
                    value={formik.values.sellerContact}
                    onChange={formik.handleChange}
                  />
                  {formik.errors.sellerContact && (
                    <div className="text-danger small mt-1">
                      {formik.errors.sellerContact}
                    </div>
                  )}
                </div>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <label htmlFor="puneAddress" className="col-form-label">
                  Pune Address <span style={{ color: "red" }}>*</span> (Full
                  Address)
                </label>
                <div className="mb-4">
                  <Input
                    id="puneAddress"
                    name="puneAddress"
                    type="textarea"
                    rows="3"
                    className="form-control"
                    value={formik.values.puneAddress}
                    onChange={formik.handleChange}
                  />
                  {formik.errors.puneAddress && (
                    <div className="text-danger small mt-1">
                      {formik.errors.puneAddress}
                    </div>
                  )}
                </div>
              </Col>
              <Col md={6}>
                <label htmlFor="permanentAddress" className="col-form-label">
                  Permanent Address <span style={{ color: "red" }}>*</span>{" "}
                  (Full Address)
                </label>
                <div className="mb-4">
                  <Input
                    id="permanentAddress"
                    name="permanentAddress"
                    type="textarea"
                    rows="3"
                    className="form-control"
                    value={formik.values.permanentAddress}
                    onChange={formik.handleChange}
                  />
                  {formik.errors.permanentAddress && (
                    <div className="text-danger small mt-1">
                      {formik.errors.permanentAddress}
                    </div>
                  )}
                </div>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <label
                  htmlFor="txtCompanyBilling"
                  className="col-form-label text-start"
                >
                  Your Facebook Profile URL{" "}
                  <span style={{ color: "red" }}>*</span>
                  {" "}(not Business page)
                </label>
                <div className="mb-4">
                  <Input
                    id="facebookLink"
                    name="facebookLink"
                    type="text"
                    className="form-control"
                    placeholder="Eg.: https://www.facebook.com/sonia.konjeti"
                    value={formik.values.facebookLink}
                    onChange={formik.handleChange}
                    onBlur={normalizeUrlOnBlur("facebookLink")}
                  />
                  {formik.errors.facebookLink && (
                    <div className="text-danger small mt-1">
                      {formik.errors.facebookLink}
                    </div>
                  )}
                </div>
              </Col>
            </Row>

            {formik.values.hasPartner && (
              <Row>
                <Col xs={12} md={6} xl={4}>
                  <label
                    htmlFor="partnerName"
                    className="col-form-label text-start"
                  >
                    Partner's Name <span style={{ color: "red" }}>*</span>
                  </label>
                  <div className="mb-4">
                    <Input
                      id="partnerName"
                      name="partnerName"
                      type="text"
                      className="form-control"
                      placeholder="Enter your partner's name"
                      value={formik.values.partnerName}
                      onChange={formik.handleChange}
                    />
                    {formik.errors.partnerName && (
                      <div className="text-danger small mt-1">
                        {formik.errors.partnerName}
                      </div>
                    )}
                  </div>
                </Col>
                <Col xs={12} md={6} xl={4}>
                  <label
                    htmlFor="partnerWhatsappNumber"
                    className="col-form-label"
                  >
                    Partner's Mobile Number{" "}
                    <span style={{ color: "red" }}>*</span>
                  </label>
                  <div className="mb-4">
                    <Input
                      id="partnerWhatsappNumber"
                      name="partnerWhatsappNumber"
                      type="tel"
                      maxLength={10}
                      inputMode="numeric"
                      className="form-control"
                      placeholder="Enter your partner's whatsapp number"
                      value={formik.values.partnerWhatsappNumber}
                      onChange={formik.handleChange}
                    />
                    {formik.errors.partnerWhatsappNumber && (
                      <div className="text-danger small mt-1">
                        {formik.errors.partnerWhatsappNumber}
                      </div>
                    )}
                  </div>
                </Col>
                <Col xs={12} md={6} xl={4}>
                  <label htmlFor="partnerEmail" className="col-form-label">
                    Partner's Email <span style={{ color: "red" }}>*</span>
                  </label>
                  <div className="mb-4">
                    <Input
                      id="partnerEmail"
                      name="partnerEmail"
                      rows="4"
                      type="email"
                      className="form-control"
                      placeholder="Enter your partner's email"
                      value={formik.values.partnerEmail}
                      onChange={formik.handleChange}
                    ></Input>
                    {formik.errors.partnerEmail && (
                      <div className="text-danger small mt-1">
                        {formik.errors.partnerEmail}
                      </div>
                    )}
                  </div>
                </Col>
                <Col md={6}>
                  <label
                    htmlFor="txtCompanyBilling"
                    className="col-form-label text-start"
                  >
                    Partner's Facebook Profile URL{" "}
                    <span style={{ color: "red" }}>*</span>
                    {" "}(not Business page)
                  </label>
                  <div className="mb-4">
                    <Input
                      id="partnerFacebookLink"
                      name="partnerFacebookLink"
                      type="text"
                      className="form-control"
                      placeholder="Eg.: https://www.facebook.com/sonia.konjeti"
                      value={formik.values.partnerFacebookLink}
                      onChange={formik.handleChange}
                      onBlur={normalizeUrlOnBlur("partnerFacebookLink")}
                    />
                    {formik.errors.partnerFacebookLink && (
                      <div className="text-danger small mt-1">
                        {formik.errors.partnerFacebookLink}
                      </div>
                    )}
                  </div>
                </Col>
              </Row>
            )}

            <div className="pvs-reg-actions actions">
              <div className="btngroup-pvs">
                <div>
                  <Button
                    color="primary"
                    size="md"
                    disabled={props.activeTab === 1}
                    onClick={() => {
                      props.toggleTab(props.activeTab - 1)
                    }}
                  >
                    <i className="dripicons-arrow-thin-left"></i>
                    <span>Previous</span>
                  </Button>
                </div>
                <div>
                  <Button type="submit" color="primary" size="md">
                    <span>
                      {props.activeTab === 5 ? "Submit" : "Save & Continue"}
                    </span>
                    <i className="dripicons-arrow-thin-right"></i>
                  </Button>
                </div>
              </div>
            </div>
          </CardBody>
        </Card>
      </Form>
      <ErrorPopup
        isOpen={isErrorOpen}
        toggle={() => setIsErrorOpen(!isErrorOpen)}
        title="Fix following errors"
        message={isErrorMessage}
      />
    </div>
  )
}

export default Step1
